var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 18.1189C2.84658 16.6356 4.88106 15.8048 7.00001 15.8048C9.11896 15.8048 11.1534 16.6356 12.6667 18.1189C14.1799 19.6022 16.2144 20.433 18.3333 20.433C20.4523 20.433 22.4868 19.6022 24 18.1189V3.54748C22.4868 5.03075 20.4523 5.86156 18.3333 5.86156C16.2144 5.86156 14.1799 5.03075 12.6667 3.54748C11.1534 2.06421 9.11896 1.2334 7.00001 1.2334C4.88106 1.2334 2.84658 2.06421 1.33334 3.54748V18.1189ZM1.33334 18.1189V29.4522",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot2);
export default __webpack_public_path__ + "static/media/snapshot2.1c1e6059d6237484edd2dfab33b008b8.svg";
export { ForwardRef as ReactComponent };